var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AvailableList',{attrs:{"loading":_vm.connectionsLoading,"connections":_vm.connections,"title":"Available for Processing Now","hide-connect":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }